import { BackgroundColors, PositiveColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const useStyles = createUseStyles(
  {
    root: {
      padding: [Spacings.s16, Spacings.s10],
      backgroundColor: BackgroundColors.tint2,
      display: 'flex',
      width: 148,
      height: 148,
      borderRadius: CornerRadius.r12,
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      rowGap: Spacings.s12,
      position: 'relative',
      border: 'none',
      cursor: 'pointer',
      '& p': {
        fontSize: FontSizes.s14,
        fontWeight: FontWeights.semibold,
        lineHeight: LineHeights.l20,
        color: PositiveColors.text.default,
      },
    },
    mediaWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 128,
      height: 88,
      '& svg': {
        width: 64,
        height: 64,
      },
    },
    image: {
      maxWidth: 128,
      maxHeight: 88,
    },

    showAll: {
      fontSize: FontSizes.s12,
      height: 'auto',
      position: 'absolute',
      top: '50%',
      transition: 'all 0.5s ease-out',
      transform: 'translateY(-50%)',
      borderRadius: CornerRadius.r24,
      cursor: 'pointer',
      opacity: 0,
    },

    showAllLink: {
      '&:hover': {
        background: BackgroundColors.transparent,
        '& $imageWrapper': {
          opacity: '0.52',
        },
        '& $showAll': {
          opacity: '100%',
        },
      },
    },
  },
  {
    name: 'template-carousel-item',
  },
);

export default useStyles;
